import { Link as Control } from 'react-router-dom';
import { clsx } from 'clsx';
import { PaletteUtils } from '@shared/utils';
import { Text } from '@shared/widgets';

interface ILinkProps {
  className?: string;
  to: string;
  title: string;
  icon: JSX.Element;
}

export const NavLink = (props: ILinkProps) => {
  return (
    <Control
      className={clsx('p-6 pr-4 bg-white dark:bg-soft-black flex items-center gap-3 no-underline text-inherit', props.className)}
      to={props.to}
    >
      <div
        className={clsx(
          'w-12 h-12 mr-3 rounded-3xl flex-none flex items-center justify-center dark:bg-primary text-ice',
          PaletteUtils.isVcfcPalette ? 'bg-primary' : 'bg-soft-black',
        )}
      >
        {props.icon}
      </div>
      <Text className={clsx(PaletteUtils.isInsigniaPalette && 'dark:!text-primary')} weight='semibold' size='xl'>
        {props.title}
      </Text>
    </Control>
  );
};
